import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Link, useHistory } from 'react-router-dom'
import {
  Container, TextField, Grid, Button, Typography, Collapse, Avatar, Paper,
} from '@material-ui/core'
import LockOpenIcon from '@material-ui/icons/LockOpen'
import { Alert } from '@material-ui/lab'
import { yupResolver } from '@hookform/resolvers/yup'
import style from './index.module.css'
import { loginRequest } from '../../../redux-saga/User/Login/Reducer'
import { loginSchema } from '../../../utils/User/validation'
import { ROUTE } from '../../../utils/User/constants/routingConfig/routeDetails'

const Login = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(loginSchema),
  })
  useSelector((state) => state.login.islogin)
  const user = JSON.parse(localStorage.getItem('user'))
  const onSubmit = (data) => {
    const { contact, password } = data
    dispatch(loginRequest({ contact, password, history }))
  }
  const error = useSelector((state) => state.login.error)
  return (
    <Container spacing={ 8 } className={ style.back }>
      <Paper elevation={ 24 }>
        <Grid container spacing={ 1 } direction='column' justify='center' alignItems='center'>
          <Grid item className={ style.space }>
            <Typography variant='h4'> Login </Typography>
          </Grid>
          <Grid container spacing={ 2 } justify='center' alignItems='center'>
            <Grid item spacing={ 2 } className={ style.space }>
              <Avatar spacing={ 2 } className={ style.space } item variant='contained' color='primary'>
                <LockOpenIcon />
              </Avatar>
            </Grid>
          </Grid>
          <form onSubmit={ handleSubmit(onSubmit) }>
            <Grid container spacing={ 7 }>
              <Grid item xs={ 12 }>
                <TextField
                  variant='outlined'
                  fullWidth
                  name='contact'
                  inputRef={ register }
                  label='Contact'
                />
                <p className={ style.error }>{errors.contact?.message}</p>
              </Grid>
            </Grid>
            <Grid container spacing={ 3 } justify='center' alignItems='center'>
              <Grid item xs={ 12 }>
                <TextField
                  variant='outlined'
                  fullWidth
                  type='password'
                  name='password'
                  inputRef={ register }
                  label='Password'
                />
                <p className={ style.error }>{errors.password?.message}</p>
              </Grid>
            </Grid>
            <Grid container className={ style.space }>
              <Collapse in={ error }>
                <Alert severity='error'>
                  Username or Password is INCORRECT :(
                </Alert>
              </Collapse>
            </Grid>
            <Grid container alignItems='center' justify='center'>
              <Grid className={ style.space }>
                <Button variant='contained' color='secondary' type='submit'> Login </Button>
              </Grid>
            </Grid>
          </form>
          <Grid>
            <p className={ style.pad }>
              New member
              <Link to={ ROUTE.SIGNUP }>
                &ensp;Sign Up&ensp;
              </Link>
            </p>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  )
}

export default Login
